import "./js/navigation"
import Accordion from "./js/Accordion"
import Stack from "./js/Stack"
import LabelsTable from "./js/LabelsTable"
import CascadingSubtopics from "./js/CascadingSubtopics"

document.addEventListener("DOMContentLoaded", function() {
	document.body.classList.remove("preload")
	Accordion.bindEvents()
	Stack.init()
	LabelsTable.init()
	CascadingSubtopics.init()

	const $ = jQuery
	//SEARCH BUTTON HEADER
	$(".header__search").click(function() {
		$(".header__search").css("display", "none")
		$(".is-search-form").toggleClass("active-search")

		if ($(".is-search-form").hasClass("active-search")) {
			$(".header__search").css("display", "none")
		} else {
			$(".header__search").css("display", "block")
		}
	})

	// Toggle mobile menu
	$(".toggleOffCanvas").click(function() {
		$(".header__bottom.offCanvas").toggleClass("active")
	})
	$(".header__bottom.offCanvas .main-nav > ul > li > a").click(function(e) {
		e.preventDefault()
		$(this).parent().toggleClass("active")
	})
	$(".header__bottom.offCanvas .submenu__title a").click(function(e) {
		e.preventDefault()
		$(this).parent().parent().toggleClass("submenu-active")
	})
})